import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { lastValueFrom } from 'rxjs';
import { MsalService } from '@azure/msal-angular';

@Injectable({
    providedIn: 'root'
})
export class GraphService {
    constructor(private http: HttpClient, private msal: MsalService) { }

    /** Graph needs an access token for User.Read (not the ID token). */
    private async getGraphToken(): Promise<string> {
        try {
            const result = await lastValueFrom(this.msal.acquireTokenSilent({ scopes: ['User.Read'] }));
            return result.accessToken;
        } catch (error: any) {
            return '';
        }
    }

    public async getUserPhoto(): Promise<any> {
        const token = await this.getGraphToken();
        if (!token) {
            return '';
        }

        const p = new Promise<any>((resolve, reject) => {
            let photo: any = "x";

            try {
                let url = "https://graph.microsoft.com/v1.0/me/photo/$value"
                let headers: HttpHeaders = new HttpHeaders({
                    Authorization: `Bearer ${token}`
                });
                let stream$ = this.http.get(url, { headers: headers, responseType: "blob" });

                if (stream$) {
                    lastValueFrom(stream$).then((response: any) => {
                        if (response) {
                            let reader: FileReader = new FileReader();
    
                            reader.readAsDataURL(response);
                            reader.onloadend = () => {
                                photo = reader.result;
    
                                resolve(photo);
                            }
                        }
                    });
                }
            } catch (error: any) {
                reject(error);
            }
        });

        return await p;
    }

    public async getUserGroups(role: any): Promise<any> {
        let results: any = null;

        try {
            let url = `https://graph.microsoft.com/v1.0/me/transitiveMemberOf/microsoft.graph.group?$count=true&$orderby=displayName&$filter=startswith(displayName, '${role}')`;
            let headers: HttpHeaders = new HttpHeaders({
                Authorization: `Bearer ${localStorage.getItem('msal.idtoken')}`,
                ConsistencyLevel: "eventual"
            });
            let stream$ = this.http.get(url, { headers: headers });

            results = await lastValueFrom(stream$);
        } catch (error: any) {
            throw error;
        }

        return results;
    }
}
